export default [
  {
    url: '/indicators-reports',
    name: "Relatórios",
    slug: "indicators-reports",
    icon: "FileTextIcon",
    i18n: "indicators-reports",
    submenu: [
      {
        url: "/indicators/date-report",
        name: "Data",
        slug: "indicators-date-report",
        i18n: "indicators-date-report"
      },
      {
        url: "/indicators/customers-report",
        name: "Clientes",
        slug: "indicators-customers-report",
        i18n: "indicators-customers-report"
      },
      {
        url: "/indicators/service-network-report",
        name: "Rede de atendimento",
        slug: "indicators-service-network-report",
        i18n: "indicators-service-network-report"
      },
    ]
  },
]